import React from "react";
import { Redirect, Route, Switch, useLocation, useRouteMatch, useParams } from "react-router-dom";

import SettingsBilling from "../views/Fleet/SettingsBilling";
import SettingsBillingEdit from "../views/Fleet/SettingsBillingEdit";
import SettingsGeneral from "../views/Fleet/SettingsGeneral";
import SettingsGeneralEdit from "../views/Fleet/SettingsGeneralEdit";
import SettingsMessaging from "../views/Fleet/SettingsMessaging";
import SettingsMessagingForm from "../views/Fleet/SettingsMessagingForm";
import SettingsPasses from "../views/Fleet/SettingsPasses";
import NewPassOffer from "../views/Fleet/NewPassOffer";
import PermissionedRoute from "./PermissionedRoute";
import Permissions from "../permissions";

export const FleetSettingsRouter = () => {
  const location = useLocation();
  const settingsBackground = location?.state?.settingsBackground || location;
  const { path } = useRouteMatch();
  const { fleetId } = useParams();

  return (
    <>
      <Switch location={settingsBackground || location}>
        <PermissionedRoute permission={Permissions.writeFleets} exact path={`${path}/general/edit`}>
          <SettingsGeneralEdit />
        </PermissionedRoute>
        <PermissionedRoute permission={Permissions.readFleets} exact path={`${path}/general`}>
          <SettingsGeneral />
        </PermissionedRoute>
        <PermissionedRoute
          permission={Permissions.writeRatePlans}
          exact
          path={`${path}/billing/edit`}
        >
          <SettingsBillingEdit />
        </PermissionedRoute>
        <PermissionedRoute permission={Permissions.readRatePlans} exact path={`${path}/billing`}>
          <SettingsBilling />
        </PermissionedRoute>
        <PermissionedRoute
          permission={[
            Permissions.feature.passes,
            Permissions.readPassOffers,
            Permissions.readPassOfferTypes,
          ]}
          exact
          path={`${path}/passes`}
        >
          <SettingsPasses />
        </PermissionedRoute>
        <PermissionedRoute
          permission={[
            Permissions.readToastMessages,
            Permissions.feature.messaging,
          ]}
          exact
          path={`${path}/messaging`}
        >
          <SettingsMessaging />
        </PermissionedRoute>
        <Route path={`${path}`}>
          <Redirect to={`/fleets/${fleetId}/settings/general`} />
        </Route>
      </Switch>

      {/* modals */}
      {settingsBackground && (
        <Switch>
          <PermissionedRoute
            permission={[
              Permissions.feature.passes,
              Permissions.readPassOffers,
              Permissions.readPassOfferTypes,
              Permissions.writePassOffers,
            ]}
            path={`${path}/passes/new`}
          >
            <NewPassOffer />
          </PermissionedRoute>
          <PermissionedRoute
            permission={[
              Permissions.readToastMessages,
              Permissions.writeToastMessages,
              Permissions.feature.messaging,
            ]}
            path={`${path}/messaging/new`}
          >
            <SettingsMessagingForm />
          </PermissionedRoute>
          <PermissionedRoute
            permission={[
              Permissions.readToastMessages,
              Permissions.writeToastMessages,
              Permissions.feature.messaging,
            ]}
            path={`${path}/messaging/:messageId/edit`}
          >
            <SettingsMessagingForm />
          </PermissionedRoute>
        </Switch>
      )}
    </>
  );
};

export default FleetSettingsRouter;
